import { api } from 'app/app.api';

import {
  AddWhatsAppPhoneNumberApiArg,
  AddWhatsAppPhoneNumberApiResponse,
  ReadWhatsAppPhoneNumbersApiResponse,
  RegisterWhatsAppPhoneNumberApiArg,
  RegisterWhatsAppPhoneNumberApiResponse,
  UpdateWhatsAppPhoneNumberQueueApiArg,
  UpdateWhatsAppPhoneNumberQueueApiResponse,
} from './types/whatsAppTwilioApi.types';

export const whatsAppTwilioApi = api
  .enhanceEndpoints({
    addTagTypes: ['WhatsAppTwilio'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      readWhatsAppPhoneNumbers: builder.query<
        ReadWhatsAppPhoneNumbersApiResponse,
        void
      >({
        query: () => ({
          version: 1,
          path: 'whatsapp/phone-numbers',
        }),
        providesTags: [{ type: 'WhatsAppTwilio', id: 'LIST' }],
      }),
      registerWhatsAppWaba: builder.mutation<
        RegisterWhatsAppPhoneNumberApiResponse,
        RegisterWhatsAppPhoneNumberApiArg
      >({
        query: ({ wabaId }) => ({
          version: 1,
          path: 'whatsapp/signup',
          method: 'POST',
          body: { wabaId },
        }),
        invalidatesTags: [{ type: 'WhatsAppTwilio', id: 'LIST' }],
      }),
      addWhatsAppPhoneNumber: builder.mutation<
        AddWhatsAppPhoneNumberApiResponse,
        AddWhatsAppPhoneNumberApiArg
      >({
        query: ({ wabaId, e164, displayName }) => ({
          version: 1,
          path: 'whatsapp/phone-number',
          method: 'POST',
          body: {
            wabaId,
            e164,
            displayName,
          },
        }),
        invalidatesTags: [{ type: 'WhatsAppTwilio', id: 'LIST' }],
      }),
      updateWhatsAppPhoneNumberQueue: builder.mutation<
        UpdateWhatsAppPhoneNumberQueueApiResponse,
        UpdateWhatsAppPhoneNumberQueueApiArg
      >({
        query: ({ phoneNumberId, queueId }) => ({
          version: 1,
          path: `whatsapp/phone-number/${phoneNumberId}`,
          method: 'PATCH',
          body: {
            default_queue_id: queueId,
          },
        }),
        invalidatesTags: [{ type: 'WhatsAppTwilio', id: 'LIST' }],
      }),
    }),
  });
